import apiClient from './client';
import type { PaginatedResponse } from '@/types/api';
import type { Need, NeedFormData, NeedFilters, NeedUpdate, NeedStatus } from '@/types/need';

export async function getNeeds(params?: NeedFilters): Promise<PaginatedResponse<Need>> {
  const response = await apiClient.get<PaginatedResponse<Need>>('/needs/', { params });
  return response.data;
}

export async function getNeed(id: string): Promise<Need> {
  const response = await apiClient.get<{ data: Need }>(`/needs/${id}`);
  return response.data.data;
}

export async function createNeed(data: NeedFormData): Promise<Need> {
  const response = await apiClient.post<{ data: Need }>('/needs/', data);
  return response.data.data;
}

export async function updateNeed(id: string, data: Partial<NeedFormData>): Promise<Need> {
  const response = await apiClient.put<{ data: Need }>(`/needs/${id}`, data);
  return response.data.data;
}

export async function deleteNeed(id: string): Promise<void> {
  await apiClient.delete(`/needs/${id}`);
}

export async function addNeedUpdate(
  needId: string,
  data: { content: string; status?: NeedStatus },
): Promise<NeedUpdate> {
  const response = await apiClient.post<{ data: NeedUpdate }>(`/needs/${needId}/updates`, data);
  return response.data.data;
}

export async function getFamilyNeeds(familyId: string): Promise<PaginatedResponse<Need>> {
  const response = await apiClient.get<PaginatedResponse<Need>>(`/families/${familyId}/needs`);
  return response.data;
}

export async function getMemberNeeds(memberId: string): Promise<PaginatedResponse<Need>> {
  const response = await apiClient.get<PaginatedResponse<Need>>(`/members/${memberId}/needs`);
  return response.data;
}
